<div class="pt-0 mt-0">

  <div class="col-md-12">
    <div class="row">
      <div class="col-md-6 text-left">
        <h3 class="primary-color">الأخبار</h3>
      </div>
    </div>
    <div class="row">
      <div class="col-md-9">
        <div class="input-group mb-3">
          <div class="input-icons">
            <i class="fa fa-search icon">
            </i>
            <input type="text" #search (keyup)="($event)"  class="form-control transparent" placeholder="بحث في الأخبار" aria-label="Recipient's username" aria-describedby="basic-addon2">
            <i class="fa fa-times-circle pointer left" *ngIf="search.value.length>0" (click)="removeSearch()"></i>

          </div>
        </div>
      </div>
      <div class="col-md-3 ml-auto">
        <button type="button" class="btn btn-outline-secondary  dashed-button"  data-toggle="modal" data-target="#myModal"  >+ إضافة خبر </button>
      </div>
    </div>
  </div>

  <div class="row" *ngIf="loader">
    <div class="col-md-12">
      <div class="text-center">
        <div class="loader"></div>
      </div>
    </div>
  </div>


  <div class="row " style="padding-left: 15px;padding-right: 15px" >
    <div class="col-md-12">
      <div class="row pt-0 mt-0" *ngFor="let n of news|search: 'title' : search.value">
        <div class="col-md-12">
          <div class="bg-white pb-2">
            <div class="row mb-0 pb-0">
              <div class="col-md-12">
                <div class=" mb-3" style="width: 100%;">
                  <div class="row no-gutters m-0 p-0">
                    <div class="col-md-2 mt-4 ml-3 mb-3">
                      <img style="  min-width: 100%;
    height: 100px;" [src]="n.img" class="card-img" alt="...">
                    </div>
                    <div class="col-md-8">
                      <div class="card-body text-left">
                        <h5 class="card-title">{{n.title}}</h5>
                        <span class="text-black-50">{{n.updatedAt|date:'yyyy/MM/dd'}}</span>
                      </div>
                    </div>
                    <div class="dropdown ml-auto">
                      <i class="fa fa-ellipsis-h text-black-50 pointer" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></i>

                      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                        <a class="dropdown-item border-bottom" data-toggle="modal" data-target="#myModal"  (click)="selectedRow(n)">تعديل</a>
                        <a class="dropdown-item border-bottom" data-toggle="modal" data-target="#deleteModal" (click)="selectedRow(n)" >حذف</a>
                      </div>
                    </div>

                  </div>
                  <div class="row m-0 p-0">
                    <div class="col-md-12 text-left">
                      <p class="card-text ">{{n.description}}</p>
<!--                      <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>-->
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-12">
                      <div class="d-flex flex-row ml-auto">
                        <div >
                          <span><i class="fa fa-eye" style="height: 0;top:0;color:cornflowerblue"> </i><span>{{n.views_user.length}}</span></span>
                        </div>
                       <div>
                         <span><i class="fa fa-heart" style="height: 0;top:0;color: red"></i><span>{{n.likes_user.length}}</span></span>

                       </div>

                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>


    </div>
  </div>

</div>


<div class="modal fade" id="myModal" role="dialog">
  <div class="modal-dialog " >

    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header background-blue-g">
        <h4 class="modal-title">{{editMode?"تعديل":"إضافة"}} خبر </h4>
        <span class="modal-title pull-left"><i id="closeNewsModal" data-dismiss="modal"  class="fa fa-times-circle pointer"></i>  </span>

      </div>
      <div class="modal-body text-left">

        <app-news [editMode]="editMode" [selectedRow]="rowSelected" (refresh)="refresh()"></app-news>
      </div>

    </div>

  </div>
</div>


<div class="modal  fade" id="deleteModal" tabindex='-1' role="dialog">
  <div class="modal-dialog " >

    <!-- Modal content-->
    <div class="modal-content   radius-16" style="width: 600px">
      <div class="modal-header background-red">
        <h4 class="modal-title">حذف  خبر</h4>
        <span class="modal-title pull-left"><i data-dismiss="modal"  class="fa fa-times-circle pointer"></i>  </span>
      </div>
      <div class="modal-body text-left">
        <div class="row">
          <div class="container text-center">
            <p class="text-black ">
              هل أنت متأكد من رغبتك في حذف   ( {{rowSelected['title']}} ) ، سيتم حذف جميع البيانات المرتبطة بهذه الخبر
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6">
            <div class="text-center">
              <button type="button" class="btn radius-16    background-red   pr-5 pl-5" data-dismiss="modal" (click)="deleteNews(rowSelected['_id'])">نعم</button>

            </div>
          </div>
          <div class="col-md-6">
            <div class="text-center">
              <button type="button"  class="btn  border background-white   pr-5 pl-5"  data-dismiss="modal" aria-label="Close">
                لا
              </button>

            </div>
          </div>
        </div>
      </div>

    </div>

  </div>
</div>
